<!--
/**
* @name: List.vue
* @description: 门店批量导入
* @author: 张露洁
* @create: 2021/04/08 17:40:00
* @update: 2021/04/08 17:40:00
*/
-->

<template>
  <y-view :loading="isLoading">
    <y-query spaceBetween :hasSearchButton="false">
      <y-query-item>
        <k-button @click="onDownLoad">下载模板</k-button>
      </y-query-item>
      <y-query-item>
        <y-upload-file
          style="width: 80px"
          acceptType=".xls,.xlsx"
          :uploadUrl="uploadUrl"
          @uploaded="onUploaded"
        >
          <k-button type="primary">导入文件</k-button>
        </y-upload-file>
      </y-query-item>
      <y-query-item>
        <k-button type="primary" @click="onAudit">批量审核</k-button>
      </y-query-item>
      <y-query-item slot="right">
        <k-button type="primary" @click="onExport">导出历史成功记录</k-button>
      </y-query-item>
    </y-query>
    <k-table
      v-if="infoList"
      hasCheckbox
      :selectedRows.sync="selectedRows"
      :selectedKeys.sync="selectedKeys"
      :data="infoList"
      checkboxKey="id"
      :draggable="true"
      :checkable="checkable"
      :height="$root.tableHeightXXX"
      :rightFixedNumber="1"
      :columns="initColumns()"
    ></k-table>
    <!-- 编辑附加条件区域 end -->
  </y-view>
</template>

<script>
import {
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_DOWNLOAD_MOULD_EXCEL,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_UPLOAD_INFO_EXCEL,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_DOWNLOAD_PASSED_LODS,
  NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_IMPORT_AUDIT,
  NESTLE_FILE_UPLOAD_SERVER_UPLOAD_OSS,
} from '@/assets/modules/apiList';

export default {
  data() {
    return {
      selectedKeys: [],
      selectedRows: [],
      infoList: [],
      isLoading: false,
      uploadUrl: NESTLE_FILE_UPLOAD_SERVER_UPLOAD_OSS,
    };
  },
  watch: {},

  methods: {
    initColumns() {
      return [
        {
          name: '序号',
          style: {
            width: 50,
            textAlign: 'center',
          },
          customRender: (t, r) => <div>{r + 1}</div>,
        },
        {
          name: '门店名称',
          field: 'name',
          style: {
            width: 120,
            textAlign: 'center',
            'white-space': 'normal',
            'word-break': 'break-all',
          },
        },
        {
          name: '推广公司编码',
          field: 'companyCode',
          style: {
            width: 100,
            textAlign: 'center',
          },
        },
        {
          name: 'DSR姓名',
          field: 'salesmanName',
          style: {
            width: 80,
            textAlign: 'center',
          },
        },
        {
          name: '客商编码',
          field: 'customerCode',
          style: {
            width: 80,
            textAlign: 'center',
          },
        },
        {
          name: '门店性质',
          field: 'attributeInfo',
          style: {
            width: 80,
            textAlign: 'center',
          },
        },
        {
          name: '门店属性',
          field: 'typeInfo',
          style: {
            width: 80,
            textAlign: 'center',
          },
        },
        {
          name: '省',
          field: 'provinceInfo',
          style: {
            width: 80,
            textAlign: 'center',
          },
        },
        {
          name: '市',
          field: 'municipalityInfo',
          style: {
            width: 80,
            textAlign: 'center',
          },
        },
        {
          name: '区',
          field: 'districtInfo',
          style: {
            width: 80,
            textAlign: 'center',
          },
        },
        {
          name: '详细地址',
          field: 'address',
          style: {
            width: 120,
            textAlign: 'center',
            'white-space': 'normal',
            'word-break': 'break-all',
          },
        },
        {
          name: '营业执照名称',
          field: 'businessLicenseName',
          style: {
            width: 120,
            textAlign: 'center',
            'white-space': 'normal',
            'word-break': 'break-all',
          },
        },
        {
          name: '统一社会信用代码',
          field: 'businessLicenseCode',
          style: {
            width: 120,
            textAlign: 'center',
            'white-space': 'normal',
            'word-break': 'break-all',
          },
        },
        {
          name: '打款类型',
          field: 'remitTypeInfo',
          style: {
            width: 80,
            textAlign: 'center',
          },
        },
        {
          name: '状态',
          field: 'status',
          style: {
            width: 80,
            textAlign: 'center',
          },
          customRender: (row) => {
            const statusStr =
              row.status == 0 ? (
                <span>导入失败</span>
              ) : row.status == 1 ? (
                <span>待审核</span>
              ) : row.status == 2 ? (
                <span>已作废</span>
              ) : row.status == 3 ? (
                <span>审核通过</span>
              ) : (
                <span>审核失败</span>
              );
            return <div>{statusStr}</div>;
          },
        },
        {
          name: '错误原因',
          field: 'failedReason',
          style: {
            width: 180,
            textAlign: 'center',
            'white-space': 'normal',
            'word-break': 'break-all',
          },
        },
        {
          name: '操作',
          field: 'action',
          style: {
            textAlign: 'center',
            width: 100,
          },
          customRender: (row) => {
            const onVerifyUpButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onAudit(row);
                }}
              >
                审核
              </a>
            );
            const onVerifyDownwButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onDel(row);
                }}
              >
                作废
              </a>
            );
            if (row.status == 1) {
              return (
                <div>
                  {onVerifyUpButton}&#12288;{onVerifyDownwButton}
                </div>
              );
            }
          },
        },
      ];
    },
    checkable(row) {
      if (row.id) {
        return [false, true];
      }
      return [true, false];
    },
    onDel(row) {
      this.$dialog({
        title: "提示",
        content: `是否确认作废该导入信息？`,
        ok: () => {
          this.infoList.map((item) => {
            if (item.id == row.id) {
              item.status = 2;
            }
          });
        },
      });
    },
    onAudit(row) {
      const selectIdList = JSON.parse(JSON.stringify(this.selectedRows)).filter((item) => item.status == 1);
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_IMPORT_AUDIT,
        para: { idList: row && row.id ? [row.id] : selectIdList.map((i) => i.id) },
      })
        .then((res) => {
          this.isLoading = false;
          this.infoList.map((item) => {
            res.map((y) => {
              if (item.id == y.id) {
                item.status = y.status;
              }
            });
          });
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    onDownLoad() {
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_DOWNLOAD_MOULD_EXCEL,
        para: {},
      })
        .then((res) => {
          this.isLoading = false;
          window.open(encodeURI(res));
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    onUploaded(data) {
      this.isLoading = true;
      let { tip } = this.$root;
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_UPLOAD_INFO_EXCEL,
        para: { excelUrl: data.data[0].url },
      })
        .then((res) => {
          this.isLoading = false;
          this.infoList = res;
          tip('数据导入成功');
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    onExport() {
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_MERCHANT_BACK_SERVER_BACK_MERCHANT_SHOP_DOWNLOAD_PASSED_LODS,
        para: {},
        isBlob: true,
        filename: "门店批量导入成功历史记录",
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
  created() {
    this.infoList = [];
  },
  beforeRouteUpdate(to, from, next) {
    this.infoList = [];
    next();
  },
};
</script>

<style lang="postcss" module="css">
</style>
